import React from 'react';
import { useNavigate } from 'react-router';
import { Spinner } from '@components/spinner';
import { StickyBar } from '@components/sticky-bar';
import { Button } from '@components/ui/button';
import { links } from '@core/router';

type Props = {
    isUpdating?: boolean;
    onChallengeCreate?(): Promise<void>;
    createDisabled?: boolean;
    showCreateButton?: boolean;
    onChallengeCancel?(): Promise<void>;
    cancelDisabled?: boolean;
    showCancelButton?: boolean;
    onChallengeEdit?(): Promise<void>;
    editDisabled?: boolean;
    showEditButton?: boolean;
    communityId: string;
};

export const ChallengeActions = ({
    isUpdating,
    createDisabled,
    showCreateButton,
    showCancelButton,
    cancelDisabled,
    editDisabled,
    showEditButton,
    onChallengeEdit,
    onChallengeCancel,
    onChallengeCreate,
    communityId
}: Props) => {
    const navigate = useNavigate();

    return (
        <StickyBar>
            <div className="flex w-full items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                    <Button
                        variant="ghost"
                        onClick={() =>
                            void navigate(
                                links.communityChallenges(communityId)
                            )
                        }
                    >
                        Back
                    </Button>
                    {isUpdating && (
                        <Spinner size="sm" className="text-muted-foreground" />
                    )}
                </div>

                <div className="flex items-center gap-4">
                    {showCreateButton && (
                        <Button
                            data-testid="schedule-challenge-button"
                            disabled={createDisabled}
                            onClick={onChallengeCreate}
                        >
                            Create
                        </Button>
                    )}

                    {showCancelButton && (
                        <Button
                            variant="destructive"
                            data-testid="cancel-challenge-button"
                            disabled={cancelDisabled}
                            onClick={onChallengeCancel}
                        >
                            Abort
                        </Button>
                    )}
                    {showEditButton && (
                        <Button
                            data-testid="cancel-challenge-button"
                            disabled={editDisabled}
                            onClick={onChallengeEdit}
                        >
                            Update Challenge
                        </Button>
                    )}
                </div>
            </div>
        </StickyBar>
    );
};
